export const environment = {
    production: true,
    runServiceWorker: false,
    restApi: {
      msB2C: "https://api.argosone.com/prod/adm/b2c/",
    },
    urlsGraphQL: {
      urlGraphQLAccounts: 'https://api.argosone.com/prod/adm/accounts/',
      urlGraphQLGeneral: "https://api.argosone.com/prod/adm/general/",
      content: "https://api.argosone.com/prod/adm/content/",
      back_office: 'https://api.argosone.com/prod/rep/sto/back-office/'
    },
    backgroundImage:"https://stadminmcfsqa001.blob.core.windows.net/standalone/bannersStore/LUZ%20VERDEB.png",
    DefaultRedirect:"https://repdominicana.argosone.com/",
    EncryptKey :"1203199320052021",
    recaptchaSiteKey:"6LdabjEqAAAAAPqFCf0UTwcrNwcNlOL18WitXcBB",
    tenantId :"Republica",
    storeId:"1ADB5C6D-DC99-4BDD-A231-DE40EA2BFAD2",
    x_token: '5902e673859c491fbb6c7800479c10f0',
    storeIdComplete:"1ADB5C6D-DC99-4BDD-A231-DE40EA2BFAD2",
    country:"DO"
  };

